import { BaseObject, SafeBaseObject } from "@app/core/models/base-object.models";
import { CoreFormatService } from "@app/core/services/core-format.service";
import { DateTime, Interval } from "luxon";
import { RescomService } from "../services/rescom.service";
import { ReservationAccomodation } from '@app/reservation/models/res-service.models';
import { BookingGuest, PriceSetupIDEnum, PriceSetupTypeEnum, ResBooking, ServiceTypeIDEnum } from "@app/reservation/models/res-booking.model";
import { v4 as uuid } from 'uuid';

export class ReservationSetupService extends SafeBaseObject {
    address?: string;
    brandID?: number;
    brands = '';
    brandIDs?: number[] | string
    city?: string;
    cityID?: number;
    companyID?: number;
    country?: string;
    countryCod?: string;
    countyCod?: string;
    currency?: string;
    discontinueDays?: number;
    discontinueDaysCru?: number;
    hasIncluded = false;
    serviceDescription?: string;
    priceSetupID?: number;
    serviceID?: number;
    serviceLongName?: string;
    serviceLedGerCode?: string;
    serviceShortName?: string;
    serviceTermsInclusions?: string;
    serviceTermsExclusions?: string;
    serviceTypeID?: number;
    serviceTypeName?: string;
    siteID?: number;
    stateCod?: string;
    status?: string;
    supplierID?: number;
    supplierName?: string;
    supplierCompanyID?: number;
    supplierCompanyName?: string;
    supplierOtherCompanyInfo?: string;
    zip?: string;
    transferIDFrom?: number;
    transferIDTo?: number;
    transferTypeIDFrom?: number;
    transferTypeIDTo?: number;
    pierFrom?: string;
    pierTo?: string;
    hotelUniqueID?: number;
    hotelName?: string;
    geoTreeID?: number;
    latitude?: number;
    longitude?: number;
    nearestAirportID?: number;
    longDescription?: string;

    serviceIDTS?: number;
    companyIDTS?: number;

    companiesIDs?: number[]; // used for the Get
    companiesID?: string; // used for the Manage

    costVAT?: number;
    priceVAT?: number;

    isGeneric = false;
    isVillaService = false;
    hideInWebsite = false;

    lookupValues: { scope: string, cod: string, desc: string }[] = [];

    spokenLanguages: string[] = [];
    cuisine: string[] = [];
    ambiance: string[] = [];
    facilities: string[] = [];
    categories: string[] = [];
    bestSuitedFor: string[] = [];
    specialInterests: string[] = [];
    accommodationStyle: string[] = [];
    amenities: string[] = [];

    type: string[] = [];
    style: string[] = [];
    physicalActivityStyle: string[] = [];
    usageTime: string[] = [];
    mobility: string[] = [];
    webDuration: string[] = [];

    descriptionAI = ''
    longDescriptionAI = ''
    hasCoordinates = false;
    companyList = ''
    excludeAvailability = false;
    dmcSupplierID = 0
    dmcSupplierName = ''
    dmcSupplierCompanyID = 0
    dmcSupplierCompanyName = ''
    dmcSupplierOtherCompanyInfo = ''
    checkIn = DateTime.invalid('empty')
    checkOut = DateTime.invalid('empty')
    serviceGroupID?: number;

    get formattedStatus(): string {
        switch (this.status) {
            case 'A': return 'Active';
            case 'D': return 'Deleted';
            case 'B': return 'Inactive';
            default: return '';
        }
    }

    consortiums: ReservationServiceConsortium[] = [];
    consortiumAgencyCodes: string[] = [];
    consortiumAgenciesString = ''
    movingTypeID?: number;
    supplierUniqueID?: number
    dMCSupplierUniqueID?: number
    isInternalFlight = false;
    isInternationalFlight = false;
    packageOnly = false;

    constructor(data?: any) {
        super();
        this.status = 'A';

        if (data) {
            this.updateData(data);
            // API uses DMC* keys that may land on dMC* via mangling; bind explicitly
            if (!this.dmcSupplierCompanyID) {
                this.dmcSupplierCompanyID = +(data.DMCSupplierCompanyID ?? data.DmcSupplierCompanyID ?? data.dMCSupplierCompanyID ?? 0)
            }
            if (!this.dmcSupplierCompanyName) {
                this.dmcSupplierCompanyName = `${data.DMCSupplierCompanyName ?? data.DmcSupplierCompanyName ?? data.dMCSupplierCompanyName ?? ''}`.trim()
            }
            if (data.Companies) this.companiesIDs = data.Companies.map((c: any) => Number(c.CompanyID))
            if (data.Facilities) this.lookupValues = data.Facilities.map((f: any) => ({ scope: f.Scope, cod: f.Cod, desc: f.Desc }))
            if (data.Companies) this.companyList = data.Companies.map((c: any) => c.CompanyName).join(', ')
            if (data.Consortiums) this.consortiums = data.Consortiums.map((c: any) => new ReservationServiceConsortium(c))

            if (this.consortiums) this.consortiumAgencyCodes = this.consortiums.map((c: ReservationServiceConsortium) => c.agencyCode)
            if (this.consortiums) this.consortiumAgenciesString = this.consortiums.map((c: ReservationServiceConsortium) => c.agency).join(', ')
            if (this.brands) {
                this.brandIDs = this.brands.split(',')
                    .map(id => +id.trim())
                    .filter(id => !!id);
            }
        }
    }

}

export interface IReservationSetupServiceCompanies {
    CompanyID: number;
    CompanyName: string;
    ServiceID?: number;
}


export class ReservationServiceType extends SafeBaseObject {
    serviceTypeID?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;
    productCod?: string;
    isSelected = false;
    guestConstraint = false;
    tabsLocation?: string;
    onBoardUse = false;
    hasCruise = false;
    defaultValuePRE = DateTime.invalid('empty');
    defaultValuePOST = DateTime.invalid('empty');
    excludeAvailability = false;
    notAvailableReason?: string
    showCityCountryFields = true; //da mod after prod release
    fixedDuration = false;

    get displayName() {
        return `${this.serviceTypeName} - ${this.serviceTypeDescription}`
    }
    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}

export class SupplierAddressType extends SafeBaseObject {
    supplierLookupID = 0;
    scope = '';
    position = 0;
    cod = '';
    desc = '';

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}
export class SupplierContactType extends SafeBaseObject {
    supplierLookupID = 0;
    scope = '';
    position = 0;
    cod = '';
    desc = '';

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}

export class SupplierDetails extends SafeBaseObject {
    addresses: SupplierDetailsAddress[] = [];
    contacts: SupplierDetailsContact[] = [];
    bankAccounts: SupplierDetailsBankAccount[] = [];

    constructor(data?: any) {
        super();
        if (data) {
            //   this.updateData(data);
            this.addresses = data.DT0.map((address: any) => new SupplierDetailsAddress(address))
            this.contacts = data.DT1.map((contact: any) => new SupplierDetailsContact(contact))
            this.bankAccounts = data.DT2.map((bankAccount: any) => new SupplierDetailsBankAccount(bankAccount))
        }
    }
}

export class SupplierDetailsAddress extends SafeBaseObject {
    supplierID = 0;
    supplierAddressID = 0;
    addressTypeCod = '';
    address = '';
    cityID = 0;
    countryCod = '';
    stateCod = '';
    countyCod = '';
    zip = '';
    phone = '';
    fax = '';
    emergencyPhone = '';
    email = '';
    webURL = '';
    note = '';
    status = 'A';

    //Used in the Supplier Unique
    supplierUniqueID = 0;
    supplierUniqueAddressID = 0;

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}

export class SupplierDetailsContact extends SafeBaseObject {
    supplierID = 0;
    supplierContactID = 0;
    contactTypeCod = '';
    title = '';
    firstName = '';
    middleName = '';
    lastName = '';
    jobTitle = '';
    department = '';
    phone = '';
    workPhone = '';
    fax = '';
    emergencyPhone = '';
    email = '';
    note = '';
    status = 'A';

    //Used in the Supplier Unique
    supplierUniqueID = 0;
    supplierUniqueContactID = 0;

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}

export class SupplierDetailsVendor extends SafeBaseObject {
    companyID = 0
    company = ''
    supplierID = 0
    supplierName = ''
    status = ''
    supplierUniqueID = 0

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }

}

export class SupplierDetailsBankAccount extends SafeBaseObject {
    supplierBankDetailID = 0;
    supplierID = 0;
    commercialName = '';
    categoryCod = '';
    accountName = '';
    bank = '';
    currency = '';
    accountNumber = '';
    CLABE = '';
    beneficiaryAddress = '';
    beneficiaryCityID = 0;
    beneficiaryZip = '';
    email = '';
    status = 'A';
    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
            this.addProperty('CLABE', data, 'CLABE');
        }
    }
}

export interface ISupplierDetailsAddress {
    SupplierAddressID?: number;
    SupplierID?: number;
    AddressTypeCod?: string;
    Address?: string;
    CityID?: number;
    CountryCod?: string;
    StateCod?: string;
    CountyCod?: string;
    Zip?: string;
    Phone?: string;
    Fax?: string;
    EmergencyPhone?: string;
    Email?: string;
    WebURL?: string;
    Note?: string;
    Status: string;
}

export interface ISupplierDetailsContact {
    SupplierContactID?: number;
    SupplierID?: number;
    ContactTypeCod?: string;
    Title?: string;
    FirstName?: string;
    MiddleName?: string;
    LastName?: string;
    JobTitle?: string;
    Department?: string;
    Phone?: string;
    WorkPhone?: string;
    Fax?: string;
    EmergencyPhone?: string;
    Email?: string;
    Note?: string;
    Status: string;
}

export interface ISupplierDetailsBankAccount {
    SupplierBankDetailID?: number;
    SupplierID?: number;
    CommercialName?: string;
    CategoryCod?: string;
    AccountName?: string;
    Bank?: string;
    Currency?: string;
    AccountNumber?: string;
    CLABE?: string;
    BeneficiaryAddress?: string;
    BeneficiaryCityID?: number;
    BeneficiaryZip?: string;
    Email?: string;
    Status: string;
}

export class SupplierDetailsBankServiceAccount extends SafeBaseObject {
    supplierLookupID = 0;
    scope = '';
    position = 0;
    cod = '';
    desc = '';

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}

export interface IReservationApiServiceType {
    ServiceTypeName?: string,
    ServiceTypeID?: number,
    BkgID?: number
}

export interface IReservationGeotreeCityPicklist {
    DestinationTypeID: number
    DestinationTypeName: string
    ExternalCityID: number | null
    ExternalCity: string | null
    GeoTreeID: number
    GeoTreeName: string
}

export class ReservationServiceData extends BaseObject {
    serviceTypeID?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;
    guestConstraint?: boolean;
    serviceID?: number;
    serviceLongName?: string;
    serviceShortName?: string;
    serviceDescription?: string;
    serviceDisplayNameUnique?: string;
    /* options?: ReservationServiceOption[];
    filteredOptions?: ReservationServiceOption[]; */
    inclusiveItems?: ReservationServiceOption[]
    filteredInclusiveItems?: ReservationServiceOption[]
    supplierName?: string;
    country?: string;
    serviceDisplayName?: string;
    supplierAccountCod?: string;
    supplierAccountCodBC?: string;
    RFC?: string;
    supplierUniqueID?: number;
    starCod?: string;
    starDesc?: string;
    isAK?: boolean;
    DmcSupplier?: string;
    amenities: ResSrvOptAmenities[] = []
    amenityCategories: ResSrvOptAmenityCategories[] = []
    amenityTagCategories: ResSrvOptAmenityCategories[] = []
    serviceGroup = ''
    communications: { title: string, notes: string }[] = [];
    offers: { title: string, offerCod: string, night: number, notes: string }[] = [];

    get serviceStars() {
        const nStar = +((this.starCod ?? '0').toLowerCase().replace(/[a-z]/g, ''))
        let stars = ''
        for (let i = 0; i < nStar; i++) {
            stars += '<span>⭐</span>'
        }
        return `${stars} ${this.starDesc ?? ''}`.trim()
    }

    constructor(
        data?: IReservationApiService,
        coreFormatService?: CoreFormatService
    ) {
        super(data);
        if (!!data) {
            this.updateData(data, coreFormatService);
        }
    }

    override updateData(
        data: IReservationApiService,
        coreFormatService?: CoreFormatService
    ): void {
        this.addMangledProperty(data);
        this.addProperty('RFC', data, 'RFC');
        this.addProperty('DmcSupplier', data, 'DMCSupplier');
        this.addBooleanProperty('guestConstraint', data, 'GuestConstraint');
        this.addBooleanProperty('isAk', data, 'IsAK');

        this.amenities = []
        this.amenityCategories = []
        this.amenityTagCategories = []

        if (data.Amenities) this.amenities = data.Amenities.filter(a => a.ServiceID === this.serviceID && a.OptionID === this.optionID).map(a => new ResSrvOptAmenities(a))

        this.amenities.forEach(a => {
            if (a.selectType !== '') {
                let cat = this.amenityCategories
                    .find(c => c.category === a.category)
                if (!cat) {
                    cat = new ResSrvOptAmenityCategories(a)
                    cat.amenitySelected = a.value
                    this.amenityCategories.push(cat)
                }
                cat.amenities.push({ code: a.value, caption: a.amenity, cod: a.cod })
            } else {
                let cat = this.amenityTagCategories
                    .find(c => c.category === a.category)
                if (!cat) {
                    cat = new ResSrvOptAmenityCategories(a)
                    cat.amenitySelected = a.value
                    this.amenityTagCategories.push(cat)
                }
                cat.amenities.push({ code: a.value, caption: a.amenity, cod: a.cod })
            }
        })
        this.inclusiveItems =
            data.InclusiveItems?.map(
                (option) => new ReservationServiceOption(option, false, coreFormatService)
            ) ?? [];

        if (!this.inclusiveItems?.length) {
            this.filteredInclusiveItems = [];
        } else {
            let options = this.inclusiveItems.filter(
                (o, i, a) => a.findIndex((x) => x.optionID === o.optionID) === i
            );


            options.forEach((o) => {
                o.allAvailableOptions = (this.inclusiveItems
                    ?.filter((x) => x.optionID === o.optionID)) ?? [];
            });
            this.filteredInclusiveItems = options;
        }

        this.communications = !!data.Communications && data.Communications.length > 0? data.Communications.map(el => { return { title: el.Title, notes: el.Notes } }) : []
        this.offers = !!data.Offers && data.Offers.length > 0 ? data.Offers.map(el => { return { title: el.Title, offerCod: el.OfferCod, night: el.Night, notes: el.Notes } }) : []

    }
}

export class ResSrvOptCost extends SafeBaseObject {
    serviceID = 0
    optionID = 0
    itineraryDate = DateTime.invalid('empty')
    guestCod = 0
    bedType = ''
    mealCod = ''
    cityTax = 0
    cost = 0
    priceSetupID = 0
    price = 0
    priceCurrency = ''
    marginCalculatorParameterID = 0
    exchangeRate = 0
    margin = 0

    computedPriceCurrCost = 0
    costSource = ''
    costSourceName = ''
    isEstimated = false

    costPriceTypeID = 0
    priceTypeID = 0
    priceTypeName = ''
    prioritySeq = 0
    priceSetupType = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResSrvOptCityTax extends SafeBaseObject {
    serviceID = 0
    optionID = 0
    itineraryDate = DateTime.invalid('empty')
    bedType = ''
    mealCod = ''
    cityTax = 0

    cityTaxType = ''
    //PMT -> Percentuale
    //FMT -> Valore

    priceSetupID = 0 //2	Per Pax - 1 Per Unit
    priceSetup = ''
    priceSetupType = ''

    constructor(data?: any) {
        super()
        this.updateData(data)

        if(this.priceSetupType==='') {
          this.priceSetupType = (this.priceSetupID === PriceSetupIDEnum.PER_PAX_PRICE_SETUP_ID ? PriceSetupTypeEnum.PER_PAX : PriceSetupTypeEnum.PER_UNIT)
        }

    }
}
export class ResSrvOptServiceTax extends SafeBaseObject {
    serviceID = 0
    optionID = 0
    itineraryDate = DateTime.invalid('empty')
    bedType = ''
    mealCod = ''
    serviceTax = 0

    serviceTaxType = ''
    //PMT -> Percentuale
    //FMT -> Valore

    priceSetupID = 0 //2	Per Pax - 1 Per Unit
    priceSetup = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResSrvOptServiceOccupancy extends SafeBaseObject {
    serviceID = 0
    optionID = 0
    occupancyRuleID = 0
    occupancyMessage = ''
    maxOccupancy = 0
    maxAdults = 0
    maxChild = 0
    childFromAge = 0
    childToAge = 0

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResSrvOptServiceUsedServiceType extends SafeBaseObject {
    serviceTypeID = 0
    serviceTypeName = ''
    itineraryDate = DateTime.invalid('empty')

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResSrvOptServiceInternalTransfer extends SafeBaseObject {
    campServiceID = 0
    campOptionID = 0
    serviceTypeID = 0
    serviceTypeName = ''
    itineraryDate = DateTime.invalid('empty')
    serviceID = 0
    serviceName = ''
    optionID = 0
    optionName = ''
    serviceGroupIdFrom = 0
    serviceGroupFrom = ''
    serviceGroupIdTo = 0
    serviceGroupTo = ''
    guestCod = ''
    cost = 0
    costCurrency = ''
    price = 0
    priceCurrency = ''
    priceSetupID = 0
    marginCalculatorParameterID = 0
    exchangeRate = 0
    margin = 0
    computedPriceCurrCost = 0
    quantity = 1


    isSelected = false

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResSrvOptServiceDistinctInternalTransfer extends ResSrvOptServiceInternalTransfer {
    guestsInternalFligth: ResSrvOptServiceInternalTransfer[] = []
}
export class ResSrvOptCalendar extends SafeBaseObject {
    serviceID = 0
    optionID = 0
    date = DateTime.invalid('empty')

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResSrvOptAmenities extends SafeBaseObject {
    amenity = ''
    category = ''
    categoryDesc = ''
    optionID = 0
    selectType = ''
    serviceID = 0
    value = ''
    cod = ''
    descr = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}
export class ResAmenityMatrix {
    category = ''
    categoryDesc = ''
    value = ''
    valueDesc = ''
}
export class ResAmenityPriceMatrix extends SafeBaseObject {
    guestCod = 0
    itineraryDate = DateTime.invalid('empty')
    price = 0
    priceToServer = 0
    priceCurrency = ''
    priceSetupID = 0
    priceSetupType = ''
    cost = 0
    cityTax = 0
    costCurrency = ''
    marginCalculatorParameterID = 0
    exchangeRate = 0
    margin = 0
    computedPriceCurrCost = 0
    costSource = ''
    costSourceName = ''
    isEstimated = false


    costPriceTypeID = 0
    priceTypeID = 0
    priceTypeName = ''
    priceSetupTypeID = 0
    prioritySeq = 0




    constructor(data?: any) {
        super()
        this.updateData(data)
        if(this.priceSetupType==='') {
          this.priceSetupType = (this.priceSetupID === PriceSetupIDEnum.PER_PAX_PRICE_SETUP_ID ? PriceSetupTypeEnum.PER_PAX : PriceSetupTypeEnum.PER_UNIT)
        }
    }
}

export class ResPriceType extends SafeBaseObject  {
  costPriceTypeID = 0
  priceTypeID = 0
  priceTypeName = ''
  priceSetupID = 0
  priceSetupType = ''
  prioritySeq = 0

  constructor(data?: any) {
    super()
    this.updateData(data)
  }
}
export class ResSrvOptAmenityCategoryMatrix extends SafeBaseObject {
    matrix: ResAmenityMatrix[] = []
    prices: ResAmenityPriceMatrix[] = []
    priceType: ResPriceType[] = []
    selectedPriceTypeID = 0
    accomodations: ReservationAccomodation[] = []
    roomSize = 2
    optionID = 0
    selectType = ''
    serviceID = 0
    isSelected: boolean | null | undefined = false
    touchId = 0
    minPax = 0
    maxPax = 0
    quantityToAdd = 0
    numberOfGuests = 1
    cityTax: ResSrvOptCityTax[] = []
    serviceTax: ResSrvOptServiceTax[] = []
    occupancy: ResSrvOptServiceOccupancy[] = []

    matrixKey = ''
    get visibleMatrix() {
        return this.matrix.filter(m => m.value != '')
    }
    get maxGuests() {
        return this.quantityToAdd * this.roomSize
    }
    get getQuantityToAdd() {
      if(!this.quantityToAdd) this.quantityToAdd=1
      return this.quantityToAdd
    }
    get bedTypeValue() {
        return this.matrix.find(a => a.category === 'BedType')?.value ?? ''
    }
    get mealCodeValue() {
        return this.matrix.find(a => a.category === 'MealPlan')?.value ?? ''
    }
    get guestIcons() {
        if (this.maxPax > 8) return []
        return new Array(this.maxPax)
    }
    constructor(data?: any) {
        super()
        this.updateData(data)
    }

    override updateData(data?: any) {
      super.updateData(data)
      this.matrixKey = `${this.optionID}|${this.bedTypeValue}|${this.mealCodeValue}`
    }
    //calculate fields
    costCurrency = ''
    calculatedPrice = 0
    calculatedCampPrice = 0
    calculatedPriceCostCurrency = 0
    priceTypeDesc = ''

    calculatedTotalPrice = 0
    calculatedTotalPriceCostCurrency = 0

    calculatedTotalTaxCostCurrency = 0
    calculatedTotalTaxPriceCurrency = 0

    calculatedTotalPriceAndTaxPriceCurrency = 0
    calculatedTotalPriceAndTaxCostCurrency = 0

    priceCurrency = ''
    calculatedCost = 0
    calculatedCampCost = 0

    calculatedCityTaxCostCurrency = 0
    calculatedCityTaxPriceCurrency = 0

    calculatedServiceTaxCostCurrency = 0
    calculatedServiceTaxPriceCurrency = 0

    calculatedPriceAndTaxPriceCurrency = 0
    calculatedPriceAndTaxCostCurrency = 0
    calculatesGuests = 1
    isEstimated = false
    costSourceName = ''
    exchangeRate = 1

    addAccomodation(opt: ReservationServiceOption, guest: BookingGuest) {
        const minPax = opt.minPax ?? this.accomodations[0]?.roomMinSize ?? 1
        const maxPax = opt.maxPax ?? this.accomodations[0]?.roomMaxSize ?? 99
        const roomDescription = (opt?.optionDesc ?? '')
        const roomOptionID = (opt?.optionID ?? 0)
        const roomOptionKey = this.matrixKey
        const roomServiceID = (opt?.serviceID ?? 0)
        const room = this.accomodations.length + 1
        const nr = ReservationAccomodation.newRoom(room)
        nr.roomMaxSize = maxPax
        nr.roomMinSize = minPax
        nr.roomDescription = roomDescription
        nr.roomOptionID = roomOptionID
        nr.roomOptionKey = roomOptionKey
        nr.occupancy = (opt?.occupancy.filter(o=>o.optionID===roomOptionID)) ?? this.occupancy
        nr.roomServiceID = roomServiceID
        nr.roomServiceName = opt.serviceName ?? ''
        nr.roomOptionName = opt.optionNameForExtend ?? ''
        nr.Guests.push(guest)
        this.accomodations.push(nr)
    }
    resizeAccomodation(opt: ReservationServiceOption | null) {
        const minPax = opt?.minPax ?? this.accomodations[0]?.roomMinSize ?? 1
        const maxPax = opt?.occupancy[0]?.maxOccupancy ?? opt?.maxPax ?? this.accomodations[0]?.roomMaxSize ?? 99
        const roomDescription = (opt?.optionDesc ?? '')
        const roomOptionID = (opt?.optionID ?? 0)
        const roomOptionKey = `${opt?.optionID ?? 0}|${this.bedTypeValue}|${this.mealCodeValue}`
        const roomServiceID = (opt?.serviceID ?? 0)
        if (this.quantityToAdd > this.accomodations.length) {
            const newRoom = this.quantityToAdd - this.accomodations.length
            const room = this.accomodations.length + 1
            for (let r = 0; r < newRoom; r++) {
                const nr = ReservationAccomodation.newRoom(room + r)
                nr.roomMaxSize = maxPax
                nr.roomMinSize = minPax
                nr.roomDescription = roomDescription
                nr.roomOptionID = roomOptionID
                nr.roomOptionKey = roomOptionKey
                nr.occupancy = opt?.occupancy.filter(o=>o.optionID===roomOptionID) ?? this.occupancy
                nr.roomServiceID = roomServiceID
                nr.roomServiceName = opt?.serviceName ?? ''
                nr.roomOptionName = opt?.optionNameForExtend ?? ''
                this.accomodations.push(nr)
            }
        } else if (this.quantityToAdd > 0 && this.quantityToAdd != this.accomodations.length) {
            this.accomodations.length = this.quantityToAdd
        }
    }
    round2Digit(n:number) {
      return Math.round(n*100)/100
    }
    recomputePriceAndCost(booking?: ResBooking,isCamp=false) {
        const guests = this.accomodations.flatMap(a => a.Guests)
        const selectedGuestsCod = guests.filter(g => g.isSelected).map(g => +g.guestCod)
        if (selectedGuestsCod.length === 0) {
            if (booking) {
                const g = booking.getAccomodations().flatMap(a => a.Guests)
                if (this.numberOfGuests === 0 && g.length > 0) {
                    selectedGuestsCod.push(+g[0].guestCod)
                } else {
                    for (let i = 0; i < this.numberOfGuests; i++) {
                        if (g[i]) selectedGuestsCod.push(+g[i].guestCod)
                    }
                }
            } else {
                if (this.prices.length > 0) selectedGuestsCod.push(+this.prices[0].guestCod)
            }
        }
        const c = this.prices
                      .filter(c => selectedGuestsCod.includes(c.guestCod))
                      .filter(c => this.priceType.length === 0 || c.priceTypeID === this.selectedPriceTypeID)

        this.costCurrency = c[0]?.costCurrency ?? ''
        this.priceCurrency = c[0]?.priceCurrency ?? ''
        const pricePerPax = c[0]?.priceSetupType === PriceSetupTypeEnum.PER_PAX
        this.priceTypeDesc = pricePerPax ? 'Per Pax' : 'Per Unit'
        this.isEstimated = c[0]?.isEstimated ?? false
        this.costSourceName = c[0]?.costSourceName ?? ''
        // const price = c[0]?.price

        this.calculatesGuests = this.accomodations.flatMap(a => a.Guests).filter(g => g.isSelected).length
        if (this.calculatesGuests === 0) this.calculatesGuests = 1

        const guestForPriceCalc = c[0]?.priceSetupID === 1 ? this.calculatesGuests : 1

        const distinctDates: ResAmenityPriceMatrix[] = []
        c.forEach(cost => {
            cost.priceToServer = cost.price / guestForPriceCalc
            if (!distinctDates.find(ddc => ddc.itineraryDate.equals(cost.itineraryDate))) {
                distinctDates.push(cost)
            }
        })

        if(isCamp && pricePerPax && guests.length>0) {


          this.calculatedPrice = 0
          this.calculatedPriceCostCurrency = 0
          this.calculatedCost = 0
          guests.forEach(g=>{
            const gprices = c.filter(c=>c.guestCod===+g.guestCod)
            gprices.forEach(p=>{
              this.calculatedPrice += p.price
              this.calculatedPriceCostCurrency += p.computedPriceCurrCost
              this.calculatedCost += p.cost
            })
          })
          this.calculatedCampPrice = this.calculatedPrice
          this.calculatedCampCost = this.calculatedCost

          this.calculatedPrice = this.round2Digit(this.calculatedPrice / this.calculatesGuests)
          this.calculatedCost = this.round2Digit(this.calculatedCost / this.calculatesGuests)

          this.calculatedCityTaxCostCurrency = 0
          if (this.cityTax.length > 0) {
              const perc = this.cityTax[0].cityTaxType === 'PMT'
              const perPax = this.cityTax[0].priceSetupType === PriceSetupTypeEnum.PER_PAX
              const guestPerPax = (perPax ? this.calculatesGuests : 1)
              this.calculatedCityTaxCostCurrency = this.cityTax.reduce((acc, tax) => {
                  return acc + (
                      (perc ? (this.calculatedCampCost / 100 * tax.cityTax / guestPerPax) : tax.cityTax)
                      *
                      guestPerPax
                  )

              }, 0)

          }

          this.calculatedServiceTaxCostCurrency = 0
          if (this.serviceTax.length > 0) {
              const perc = this.serviceTax[0].serviceTaxType === 'PMT'
              const perPax = this.serviceTax[0].priceSetupID === 2

              this.calculatedServiceTaxCostCurrency = this.serviceTax.reduce((acc, tax) => {
                  return acc + (
                      (perc ? (this.calculatedCampCost / 100 * tax.serviceTax) : tax.serviceTax)
                      *
                      (perPax ? this.calculatesGuests : 1)
                  )

              }, 0)

          }

          this.calculatedTotalTaxCostCurrency = this.calculatedCityTaxCostCurrency + this.calculatedServiceTaxCostCurrency
          //2026.06.23 CityTax and ServiceTax are always in const currency
          this.calculatedCityTaxPriceCurrency = this.calculatedCityTaxCostCurrency * this.exchangeRate
          this.calculatedServiceTaxPriceCurrency = this.calculatedServiceTaxCostCurrency * this.exchangeRate
          this.calculatedTotalTaxPriceCurrency = this.calculatedCityTaxPriceCurrency + this.calculatedServiceTaxPriceCurrency

          this.calculatedTotalPrice = this.calculatedCampPrice * (pricePerPax ? 1 : this.quantityToAdd)
          this.calculatedTotalPriceCostCurrency = this.calculatedPriceCostCurrency * (pricePerPax ? 1 : this.quantityToAdd)

          this.calculatedPriceAndTaxPriceCurrency = (this.calculatedCampPrice + this.calculatedTotalTaxPriceCurrency) *  (pricePerPax ? 1 : (!this.quantityToAdd ? 1 : this.quantityToAdd))
          this.calculatedPriceAndTaxCostCurrency = (this.calculatedPriceCostCurrency + this.calculatedTotalTaxCostCurrency) * (pricePerPax ? 1 : (!this.quantityToAdd ? 1 : this.quantityToAdd))

          this.calculatedTotalPriceAndTaxPriceCurrency = this.calculatedPriceAndTaxPriceCurrency
          this.calculatedTotalPriceAndTaxCostCurrency = this.calculatedPriceAndTaxCostCurrency

        } else {


          this.calculatedPrice = distinctDates.reduce((acc, cost) => acc + cost.price, 0)
          this.calculatedPriceCostCurrency = distinctDates.reduce((acc, cost) => acc + cost.computedPriceCurrCost, 0)
          this.calculatedCost = distinctDates.reduce((acc, cost) => acc + cost.cost, 0)


          this.calculatedCityTaxCostCurrency = 0
          if (this.cityTax.length > 0) {
              const perc = this.cityTax[0].cityTaxType === 'PMT'
              const perPax = this.cityTax[0].priceSetupType === PriceSetupTypeEnum.PER_PAX
              const guestPerPax = (perPax ? this.calculatesGuests : 1)
              this.calculatedCityTaxCostCurrency = this.cityTax.reduce((acc, tax) => {
                  return acc + (
                      (perc ? (this.calculatedCost / 100 * tax.cityTax / guestPerPax) : tax.cityTax)
                      *
                      guestPerPax
                  )

              }, 0)

          }

          this.calculatedServiceTaxCostCurrency = 0
          if (this.serviceTax.length > 0) {
              const perc = this.serviceTax[0].serviceTaxType === 'PMT'
              const perPax = this.serviceTax[0].priceSetupID === 2

              this.calculatedServiceTaxCostCurrency = this.serviceTax.reduce((acc, tax) => {
                  return acc + (
                      (perc ? (this.calculatedCost / 100 * tax.serviceTax) : tax.serviceTax)
                      *
                      (perPax ? this.calculatesGuests : 1)
                  )

              }, 0)

          }

          this.calculatedTotalTaxCostCurrency = this.calculatedCityTaxCostCurrency + this.calculatedServiceTaxCostCurrency
          //2026.06.23 CityTax and ServiceTax are always in const currency
          this.calculatedCityTaxPriceCurrency = this.calculatedCityTaxCostCurrency * this.exchangeRate
          this.calculatedServiceTaxPriceCurrency = this.calculatedServiceTaxCostCurrency * this.exchangeRate
          this.calculatedTotalTaxPriceCurrency = this.calculatedCityTaxPriceCurrency + this.calculatedServiceTaxPriceCurrency

          this.calculatedTotalPrice = this.calculatedPrice * (pricePerPax ? this.calculatesGuests : this.quantityToAdd)
          this.calculatedTotalPriceCostCurrency = this.calculatedPriceCostCurrency * (pricePerPax ? this.calculatesGuests : this.quantityToAdd)

          this.calculatedPriceAndTaxPriceCurrency = (this.calculatedPrice + this.calculatedTotalTaxPriceCurrency) *  (pricePerPax ? 1 : (!this.quantityToAdd ? 1 : this.quantityToAdd))
          this.calculatedPriceAndTaxCostCurrency = (this.calculatedPriceCostCurrency + this.calculatedTotalTaxCostCurrency) * (pricePerPax ? 1 : (!this.quantityToAdd ? 1 : this.quantityToAdd))

          this.calculatedTotalPriceAndTaxPriceCurrency = this.calculatedPriceAndTaxPriceCurrency * (pricePerPax ? this.calculatesGuests : 1)
          this.calculatedTotalPriceAndTaxCostCurrency = this.calculatedPriceAndTaxCostCurrency * (pricePerPax ? this.calculatesGuests : 1)

        }
    }
    clearAccomodation() {
        this.accomodations.length = 0
    }
    calculateMinQuantityToAdd(booking: ResBooking, option: ReservationServiceOption, onlyGuestCods?: string[]) {
      const allGuests = booking.getAccomodations().flatMap(a => a.Guests)
                               .filter(g => !onlyGuestCods || onlyGuestCods.includes(g.guestCod))
      const maxRuleOccupancy = option.occupancy[0]?.maxOccupancy ?? this.accomodations[0]?.roomMaxSize ?? allGuests.length
      const maxAdults = option.occupancy[0]?.maxAdults
      const maxChild = option.occupancy[0]?.maxChild
      const childToAge = (option.occupancy[0]?.childToAge ?? 0) === 0 ? 16: option.occupancy[0].childToAge

      let countGuests = 0
      let countAdult = 0
      let countChild = 0

      let qty=1
      allGuests.forEach(guest=>{
        countGuests += 1
        if(guest.isAdult || (guest.isChild && guest.age > childToAge)) countAdult++
        //else if(guest.isChild && guest.age> childFromAge) countChild++
        else if(guest.isChild) countChild++

        if(countGuests>maxRuleOccupancy || countAdult>maxAdults || countChild>maxChild) {
          qty += 1
          countGuests = 0
          countAdult = 0
          countChild = 0
        }

      })
      return qty
    }
    applyAutoAccomodation(booking: ResBooking, option: ReservationServiceOption,applyMinQty=true,applyOnEmptyRooom=false,onlyGuestCods?: string[]) {
      if(option.skipPropagationEvent) {
        return
      }
      const modeGroup = true
      const bkgAcc = booking.getAccomodations(true)
      const bkgGuests = bkgAcc.flatMap(a => a.Guests)
                              .filter(g => !onlyGuestCods || onlyGuestCods.includes(g.guestCod))
      const accGuest = this.accomodations.flatMap(a => a.Guests)
      if (modeGroup) {
          const totalGuests = onlyGuestCods ? bkgGuests.length : bkgAcc.reduce((acc, cur) => acc + cur.Adult + cur.Child + cur.Child2, 0)
          const maxRuleOccupancy = option.occupancy[0]?.maxOccupancy ?? this.accomodations[0]?.roomMaxSize ?? option.maxPax ?? totalGuests
          if(!applyOnEmptyRooom || this.quantityToAdd===0) {
            this.quantityToAdd = Math.max(Math.ceil(totalGuests / maxRuleOccupancy), this.quantityToAdd)
          }
          const maxAdults = option.occupancy[0]?.maxAdults ?? maxRuleOccupancy
          const maxChild = option.occupancy[0]?.maxChild ?? maxRuleOccupancy
          const childToAge = (option.occupancy[0]?.childToAge ?? 0) === 0 ? 16: option.occupancy[0].childToAge
          //const childFromAge = option.occupancy[0].childFromAge

          if(applyMinQty) {
            const minQty = this.calculateMinQuantityToAdd(booking,option,onlyGuestCods)
            if(minQty>this.quantityToAdd) this.quantityToAdd = minQty
          }
          this.resizeAccomodation(option)

          this.accomodations
              .forEach(a => {
                a.roomMaxSize = maxRuleOccupancy
                if ((a.Guests?.length ?? 0) === 0) {

                    const guestNotSelected = bkgGuests
                        .filter(g =>
                            !accGuest.find(ag => ag.guestCod === g.guestCod
                            ))

                    let countAdult=0
                    let countChild=0
                    guestNotSelected.forEach(guest=>{
                      if(guest.isAdult || (guest.isChild && guest.age > childToAge)) countAdult++
                      //else if(guest.isChild && guest.age> childFromAge) countChild++
                      else if(guest.isChild) countChild++

                      if(countAdult>maxAdults) return
                      if(countChild>maxChild) return

                      a.Guests.push(guest)
                      accGuest.push(guest)

                    })

                }
              })

          if(applyMinQty) {
            //se ci sono guest non sistemati aggiungo una room e li sistemo li
            const unaccomodateGuest = bkgGuests
                                            .filter(g =>
                                                !accGuest.find(ag => ag.guestCod === g.guestCod
                                                ))
            if(unaccomodateGuest.length>0) {
              this.quantityToAdd += 1
              this.resizeAccomodation(option)
              const emptyRoom = this.accomodations.find(a=>a.Guests.length===0)
              if(emptyRoom){
                unaccomodateGuest.forEach(guest=>{
                  emptyRoom.Guests.push(guest)
                })
              }
            }
          }

          //se ci sono accomodation vuote metto dentro almeno un guest
          if(applyOnEmptyRooom) {
            const emptyAcc = this.accomodations.filter(a=>a.Guests.length===0 && a.roomMaxSize > 0)
            emptyAcc.forEach(a => {
              const accWithMoreThenOneGuest = this.accomodations.find(a=>a.Guests.length>1)
              if(!accWithMoreThenOneGuest) return

              const idxLastGuest = accWithMoreThenOneGuest.Guests.length-1
              const guest = accWithMoreThenOneGuest.Guests[idxLastGuest]
              if(!guest) return
              accWithMoreThenOneGuest.Guests.splice(idxLastGuest,1)
              a.Guests.push(guest)
            })

          }

      } else {
          this.quantityToAdd = Math.max(bkgAcc.length, this.quantityToAdd)
          this.resizeAccomodation(null)
          const unaccomadateGroups = bkgAcc.filter(a => !a.Guests?.find(g => accGuest.find(ag => ag.guestCod === g.guestCod)))

          this.accomodations
              .filter(a => (a.Guests?.length ?? 0) === 0 && a.roomMaxSize > 0 && unaccomadateGroups.length > 0)
              .forEach(a => {
                  const group = unaccomadateGroups[0]
                  if (!group.Guests) group.Guests = []
                  const k = Math.min(a.roomMaxSize, group.Guests.length)

                  group.Guests.forEach((g, idx) => {
                      if (idx < k) {
                          a.Guests.push(g)
                      }
                  })
                  unaccomadateGroups.splice(0, 1)
              })

            if (this.accomodations.length > 0) {
                const guestNotSelected = bkgAcc.flatMap(a => a.Guests ?? [])
                    .filter(g =>
                        !this.accomodations
                            .flatMap(a => a.Guests ?? [])
                            .find(ag => ag.guestCod === g.guestCod
                            ))
                let minPax = this.accomodations[0].roomMinSize ?? 1
                let maxPax = this.accomodations[0].roomMaxSize ?? 99
                if (minPax === 0) minPax = 1
                if (maxPax === 0) maxPax = 99
                const roomDescription = this.accomodations[0].roomDescription ?? ''
                const roomOptionID = this.accomodations[0].roomOptionID ?? 0
                const roomOptionkey = this.accomodations[0].roomOptionKey ?? ''
                const roomServiceID = this.accomodations[0].roomServiceID ?? 0
                const roomOccupancy: ResSrvOptServiceOccupancy[] = this.accomodations[0].occupancy
                const roomServiceName = this.accomodations[0].roomServiceName ?? ''
                const roomOptionName = this.accomodations[0].roomOptionName ?? ''
                while (guestNotSelected.length > 0) {
                    //   //put all in other rooms
                    const room = this.accomodations.length + 1
                    const nr = ReservationAccomodation.newRoom(room)
                    nr.roomMaxSize = maxPax
                    nr.roomMinSize = minPax
                    nr.roomDescription = roomDescription
                    nr.roomOptionID = roomOptionID
                    nr.roomOptionKey = roomOptionkey
                    nr.occupancy = roomOccupancy
                    nr.roomServiceID = roomServiceID
                    nr.roomServiceName = roomServiceName
                    nr.roomOptionName = roomOptionName
                    const accomodateThisGuest = guestNotSelected.splice(0, maxPax)
                    accomodateThisGuest.forEach(g => {
                        nr.Guests.push(g)
                    })
                    this.accomodations.push(nr)
                    this.quantityToAdd += 1
                }
          }
      }


    }

}

export class ResSrvOptAmenityCategories extends SafeBaseObject {
    amenities: { code: string, caption: string, cod?: string }[] = []
    amenitySelected = ''
    category = ''
    categoryDesc = ''
    optionID = 0
    selectType = ''
    serviceID = 0

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export class ReservationServiceOption extends BaseObject {
    serviceTypeID?: number;
    serviceTypeName?: string;
    serviceTypeDescription?: string;
    guestConstraint?: boolean;
    serviceID?: number;
    serviceLongName?: string;
    serviceShortName?: string;
    serviceName?: string;
    serviceDescription?: string;
    supplierName?: string;
    optionID?: number;
    optionCod?: string;
    minPax?: number;
    maxPax?: number;
    get occupancyMaxPax() {
      return this.occupancy[0]?.maxOccupancy ?? this.maxPax
    }
    needMessage?: boolean;
    csFlag?: boolean;
    optionName?: string;
    optionShortName?: string;
    optionDesc?: string;
    estimatedCost?: number;
    cost?: number;
    costTypeID?: number;
    costCurrency?: string;
    priceSetUp?: string;
    priceSetupID?: number;
    sellingPrice?: number;
    sellingPriceCurrency?: string;
    sellingTax?: number;
    costTax?: number;
    priceCurrency?: string;
    currency?: string;
    margin?: number;
    date?: DateTime;
    selfIncluded?: boolean;
    iNCServiceTypeID?: number;
    isDayRoom?: boolean;
    minNight = ''
    accomodations: ReservationAccomodation[] = []
    isSelected = false
    get hasRowSelected() {
      return !!this.amenityMatrix.find(r=>r.isSelected)
    }

    _allAvailableOptions: ReservationServiceOption[] = [this];
    get allAvailableOptions(): ReservationServiceOption[] {
        return this._allAvailableOptions;
    }
    set allAvailableOptions(value: ReservationServiceOption[]) {
        this._allAvailableOptions = value;
        this.itineraryDateStart = [...this.availableDates][0];
        this.itineraryDateEnd = [...this.availableDates].at(-1);
    }
    allAvailableOptionsGiftAndMerchandising: ReservationServiceOption[] = []
    isExceptionFilterDateForGiftAndMerchandising = false
    _itineraryDateStart?: DateTime;
    _itineraryDateEnd?: DateTime;
    valueType?: 'Amount' | 'Percentage';
    formattedPrice?: string;
    formattedSellingTax?: string;
    formattedCost?: string;
    formattedDate?: string;
    startDate?: DateTime;
    endDate?: DateTime;
    message: string = '';
    isIncluded?: boolean;
    prePostFlag?: string
    _onCheckIn?: boolean;
    _onCheckOut?: boolean;
    availableOnCheckIn?: boolean;
    availableOnCheckOut?: boolean;
    onBoardUse?: boolean; // provided by the service type and setted by the FE
    CommissionableSO?: boolean;
    onHoldQTY?: number;
    guestCod?: string;
    onRequest?: boolean;
    quantityToAdd?: number = 1;
    checked?: boolean = false;
    eRES?: boolean = false;
    serviceGroupID = 0
    serviceGroup = ''

    availableSelectedOptionsDetail: IReservationOptionDetail[] = []

    coreFormatService?: CoreFormatService;

    descriptionFull = ''
    messageAlreadySaved = false

    experienceMode = false
    amenities: ResSrvOptAmenities[] = []
    amenityTagCategories: ResSrvOptAmenityCategories[] = []
    amenityCategories: ResSrvOptAmenityCategories[] = []
    amenityMatrix: ResSrvOptAmenityCategoryMatrix[] = []
    calendar: ResSrvOptCalendar[] = []
    optionIsEnabled = false
    costGrid: ResSrvOptCost[] = []
    cityTaxGrid: ResSrvOptCityTax[] = []
    serviceTaxGrid: ResSrvOptServiceTax[] = []
    occupancy: ResSrvOptServiceOccupancy[] = []
    usedServiceType: ResSrvOptServiceUsedServiceType[] = []
    internalTransfer: ResSrvOptServiceInternalTransfer[] = []
    distinctInternalTransfer: ResSrvOptServiceDistinctInternalTransfer[] = []
    selectedGetsCod: string[] = []
    priceSetupType = ''
    //not from FE
    retriveFromServiceIsAk = false
    skipPropagationEvent = false
    get selectedCost() {
        const bedType = this.amenityCategories.find(a => a.category === 'BedType')?.amenitySelected ?? ''
        const mealCod = this.amenityCategories.find(a => a.category === 'MealPlan')?.amenitySelected ?? ''
        return this.costGrid?.filter(c => c.bedType === bedType && c.mealCod === mealCod) ?? []
    }

    get isAccomodation() {
      return this.serviceTypeID  === ServiceTypeIDEnum.ACCOMODATION_SERVICE_TYPE_ID
    }
    get isTrasport() {
      return this.serviceTypeID  === ServiceTypeIDEnum.TRANSPORTS_SERVICE_TYPE_ID
    }
    get hasRoomGuid() {
      return this.serviceTypeID  === ServiceTypeIDEnum.TRANSPORTS_SERVICE_TYPE_ID
          || this.serviceTypeID  === ServiceTypeIDEnum.OVERNIGHT_CRUISE_SERVICE_TYPE_ID
          || this.serviceTypeID  === ServiceTypeIDEnum.SLEEPER_TRAIN_SERVICE_TYPE_ID
          || this.serviceTypeID  === ServiceTypeIDEnum.ACCOMODATION_SERVICE_TYPE_ID
    }

    // if the option is inclusive itineraryDateStart and itineraryDateEnd are checkIn and checkOut dates, otherwise they are the selected daterange

    isNewVersion = false
    constructor(
        data: IReservationApiServiceOption,
        isNewVersion = false,
        coreFormatService?: CoreFormatService,
    ) {
        super(data);
        this.isNewVersion = isNewVersion
        this.coreFormatService = coreFormatService
        this.updateData(data);
    }

    static useRoomGuid(serviceTypeID:number) {
      return serviceTypeID  === ServiceTypeIDEnum.TRANSPORTS_SERVICE_TYPE_ID
          || serviceTypeID  === ServiceTypeIDEnum.OVERNIGHT_CRUISE_SERVICE_TYPE_ID
          || serviceTypeID  === ServiceTypeIDEnum.SLEEPER_TRAIN_SERVICE_TYPE_ID
          //|| serviceTypeID  === ServiceTypeIDEnum.ACCOMODATION_SERVICE_TYPE_ID
    }

    override updateData(
        data: IReservationApiServiceOption,
    ): void {
        this.addMangledProperty(data);
        this.addDateTimeProperty('date', data, 'Date');
        this.addDateTimeProperty('startDate', data, 'StartDate');
        this.addDateTimeProperty('endDate', data, 'EndDate');
        this.addBooleanProperty('needMessage', data, 'NeedMessage');
        this.addBooleanProperty('csFlag', data, 'CsFlag');
        this.addBooleanProperty('isIncluded', data, 'IsIncluded');
        this.addBooleanProperty('commissionableSO', data, 'CommissionableSO');
        this.addBooleanProperty('onBoardUse', data, 'OnBoardUse');
        this.addBooleanProperty('selfIncluded', data, 'SelfIncluded');
        this.addBooleanProperty('onRequest', data, 'OnRequest');
        this.addBooleanProperty('isDayRoom', data, 'IsDayRoom');
        this.addBooleanProperty('eRES', data, 'ERES');

        this.amenities = []
        this.amenityTagCategories = []
        this.amenityCategories = []
        this.amenityMatrix = []
        this.calendar = []
        this.cityTaxGrid = []
        this.serviceTaxGrid = []
        this.occupancy = []
        this.usedServiceType = []
        this.internalTransfer = []
        this.distinctInternalTransfer = []


        if (data.Amenities) this.amenities = data.Amenities.filter(a => a.ServiceID === this.serviceID && a.OptionID === this.optionID).map(a => new ResSrvOptAmenities(a))

        this.amenities.forEach(a => {
            if (a.selectType !== '') {
                let cat = this.amenityCategories
                    .find(c => c.category === a.category)
                if (!cat) {
                    cat = new ResSrvOptAmenityCategories(a)
                    cat.amenitySelected = a.value
                    this.amenityCategories.push(cat)
                }
                cat.amenities.push({ code: a.value, caption: a.amenity, cod: a.cod })
            } else {
                let cat = this.amenityTagCategories
                    .find(c => c.category === a.category)
                if (!cat) {
                    cat = new ResSrvOptAmenityCategories(a)
                    cat.amenitySelected = a.value
                    this.amenityTagCategories.push(cat)
                }
                cat.amenities.push({ code: a.value, caption: a.amenity, cod: a.cod })
            }
        })


        if (data.Calendar) {
            this.calendar = data.Calendar
                .filter(c => c.ServiceID === this.serviceID && c.OptionID === this.optionID)
                .map(a => new ResSrvOptCalendar(a))
        }

        if (data.CityTaxGrid) {
            this.cityTaxGrid = data.CityTaxGrid
                .filter(c => c.ServiceID === this.serviceID && c.OptionID === this.optionID)
                .map(a => new ResSrvOptCityTax(a))
        }

        if (data.ServiceTaxGrid) {
            this.serviceTaxGrid = data.ServiceTaxGrid
                .filter(c => c.ServiceID === this.serviceID && c.OptionID === this.optionID)
                .map(a => new ResSrvOptServiceTax(a))
        }

        if (data.Occupancy) {
            this.occupancy = data.Occupancy.map(item => new ResSrvOptServiceOccupancy(item))
        }
        if (data.UsedServiceType) {
            this.usedServiceType = data.UsedServiceType.map(item => new ResSrvOptServiceUsedServiceType(item))
        }
        if (data.InternalFligth) {
            this.internalTransfer = data.InternalFligth
                .filter(item => item.CampServiceID === this.serviceID && item.CampOptionID === this.optionID)
                .map(item => new ResSrvOptServiceInternalTransfer(item))
        }
        if (data.CostGrid) {
            this.costGrid = data.CostGrid
                .filter(c => c.ServiceID === this.serviceID && c.OptionID === this.optionID)
                .map(a => new ResSrvOptCost(a))

            if (this.costGrid.length > 0) {
                const gc = this.costGrid[0].guestCod
                const iDate = this.costGrid[0].itineraryDate
                this.costGrid
                    .filter(cg => cg.guestCod === gc && cg.itineraryDate.equals(iDate))
                    .forEach(cg => {

                        const pt = new ResPriceType({
                                          priceTypeID: cg.priceTypeID,
                                          costPriceTypeID: cg.costPriceTypeID,
                                          priceTypeName: cg.priceTypeName,
                                          priceSetupID: cg.priceSetupID,
                                          priceSetupType: cg.priceSetupType,
                                          prioritySeq: cg.prioritySeq
                                        })
                        let am = this.isNewVersion
                                ?
                                this.amenityMatrix.find(am=>am.bedTypeValue===cg.bedType && am.mealCodeValue === cg.mealCod)
                                :
                                undefined
                        if(!am) {
                          const am = new ResSrvOptAmenityCategoryMatrix()
                          am.serviceID = cg.serviceID
                          am.optionID = cg.optionID
                          am.minPax = this.minPax ?? 1
                          am.maxPax = this.maxPax ?? 99
                          am.exchangeRate = cg.exchangeRate
                          if (am.exchangeRate === 0) am.exchangeRate = 1

                          am.prices = this.costGrid
                              .filter(item => item.bedType === cg.bedType && item.mealCod === cg.mealCod)
                              .map(item => new ResAmenityPriceMatrix(item))
                          am.cityTax = this.cityTaxGrid
                              .filter(item => item.bedType === cg.bedType && item.mealCod === cg.mealCod)
                          am.serviceTax = this.serviceTaxGrid
                              .filter(item => item.bedType === cg.bedType && item.mealCod === cg.mealCod)
                          am.occupancy = this.occupancy.filter(item => item.serviceID === am.serviceID && item.optionID === am.optionID)

                          const bt = this.amenityCategories.find(ac => ac.category === 'BedType')
                          if (bt) {
                              am.matrix.push({
                                  category: bt.category,
                                  categoryDesc: bt.categoryDesc,
                                  value: cg.bedType,
                                  valueDesc: bt.amenities.find(a => a.code === cg.bedType)?.caption ?? cg.bedType,
                              })
                          } else {
                              am.matrix.push({
                                  category: 'BedType',
                                  categoryDesc: '',
                                  value: '',
                                  valueDesc: '',
                              })

                          }
                          const mp = this.amenityCategories.find(ac => ac.category === 'MealPlan')
                          if (mp) {
                              am.matrix.push({
                                  category: mp.category,
                                  categoryDesc: mp.categoryDesc,
                                  value: cg.mealCod,
                                  valueDesc: mp.amenities.find(a => a.code === cg.mealCod)?.caption ?? cg.mealCod,
                              })
                          } else {
                              am.matrix.push({
                                  category: 'MealPlan',
                                  categoryDesc: '',
                                  value: '',
                                  valueDesc: '',
                              })

                          }
                          am.cityTax = this.cityTaxGrid
                              .filter(tax =>
                                  tax.bedType === cg.bedType
                                  &&
                                  tax.mealCod === cg.mealCod
                              )

                          am.serviceTax = this.serviceTaxGrid
                              .filter(tax =>
                                  tax.bedType === cg.bedType
                                  &&
                                  tax.mealCod === cg.mealCod
                              )

                          am.recomputePriceAndCost()
                          am.matrixKey = `${am.optionID}|${am.bedTypeValue}|${am.mealCodeValue}`
                          if(pt.priceTypeID > 0) {
                            am.priceType.push(pt)
                          }
                          this.amenityMatrix.push(am)
                        } else {
                          if(pt.priceTypeID > 0) {
                            am.priceType.push(pt)
                          }
                        }
                    })
                    this.amenityMatrix.forEach(am=>{
                      if(am.priceType.length > 0 && am.selectedPriceTypeID === 0) {
                        am.priceType.sort((a,b)=>a.prioritySeq-b.prioritySeq)
                        am.selectedPriceTypeID  = am.priceType[0].priceTypeID
                      }
                    })
            }

        }

        if((this.priceSetupType ?? '') === '' && this.costGrid?.length>0) {
          this.priceSetupType = this.costGrid[0].priceSetupType
        }

        this.experienceMode = this.amenities.length > 0
        this.optionIsEnabled = true
        if (this.startDate && this.startDate.isValid && this.endDate && this.endDate.isValid) {

            const rangeDays = Interval.fromDateTimes(
                this.startDate,
                this.endDate
            ).splitBy({ day: 1 });
            this.optionIsEnabled = rangeDays.filter(d => !!this.calendar.find(c => c.date.equals(d.start))).length === 0;
        } else if (this.date && this.date.isValid) {
            this.optionIsEnabled = !this.calendar.find(c => c.date.equals(this.date!));
        }


        if (this.cost === undefined || this.cost === null) this.cost = 0
        if (this.costTax === undefined || this.costTax === null) this.costTax = 0
        if (this.costCurrency === undefined || this.costCurrency === null) this.costCurrency = this.sellingPriceCurrency

        this.formattedPrice = this.formatOptionPrices(
            'sellingPrice',
            this.coreFormatService
        );
        this.formattedSellingTax = this.formatOptionPrices(
            'sellingTax',
            this.coreFormatService
        );
        this.formattedCost = this.formatOptionPrices('cost', this.coreFormatService);
        this.formattedDate = this.formatOptionDate(this.coreFormatService);

        this.descriptionFull = `${this.serviceTypeDescription ?? ''} ${this.serviceLongName ?? this.serviceName ?? ''} ${this.optionName ?? this.optionShortName ?? ''}`.trim()
        this.recalculateSelectedOptionsDetail();
    }

    get onCheckIn(): boolean | undefined {
        return this._onCheckIn;
    }
    set onCheckIn(value: boolean | undefined) {
        this._onCheckIn = value;
        if (value) this.itineraryDateStart = this.availableDates[0];
        else if (this.isIncluded) this.itineraryDateStart = undefined;
    }

    get onCheckOut(): boolean | undefined {
        return this._onCheckOut;
    }
    set onCheckOut(value: boolean | undefined) {
        this._onCheckOut = value;
        if (value) this.itineraryDateEnd = this.availableDates.at(-1);
        else if (this.isIncluded) this.itineraryDateEnd = undefined;
    }

    get rangeDateStart() {
        let dt = this.itineraryDateStart ?? this.startDate ?? this.date
        if (dt) return dt
        return DateTime.invalid('empty')
    }
    get rangeDateEnd() {
        let dt = this.itineraryDateEnd ?? this.startEnd ?? this.rangeDateStart
        if (dt) return dt
        return DateTime.invalid('empty')
    }

    get priceTotal() {
        const cur = this.amenityMatrix.find(am => am.isSelected)?.priceCurrency
        return this.amenityMatrix
            .filter(am => am.isSelected && am.priceCurrency === cur)
            .reduce((acc, item) =>
                acc + item.calculatedTotalPrice,
                0
            )
    }
    get taxTotal() {
        const cur = this.amenityMatrix.find(am => am.isSelected)?.priceCurrency
        return this.amenityMatrix
            .filter(am => am.isSelected && am.priceCurrency === cur)
            .reduce((acc, item) =>
                acc + item.calculatedTotalTaxCostCurrency,
                0
            )
    }
    get priceTotalCurrency() {
        return this.amenityMatrix
            .find(am => am.isSelected)?.priceCurrency
    }
    get priceTotalTypeDesc() {
        return this.amenityMatrix
            .find(am => am.isSelected)?.priceTypeDesc
    }
    get itineraryDateStart(): DateTime | undefined {
        return this._itineraryDateStart;
    }
    set itineraryDateStart(value: DateTime | undefined) {
        this._itineraryDateStart = value;
        this.recalculateSelectedOptionsDetail()

    }

    get itineraryDateEnd(): DateTime | undefined {
        return this._itineraryDateEnd;
    }
    set itineraryDateEnd(value: DateTime | undefined) {
        this._itineraryDateEnd = value;
        this.recalculateSelectedOptionsDetail()
    }


    public get isPercentage(): boolean {
        return this.valueType?.toLowerCase() === 'percentage';
    }

    public get isAmount(): boolean {
        return this.valueType?.toLowerCase() === 'amount';
    }

    public get isPre(): boolean {
        return this.prePostFlag?.toLowerCase() === 'pre';
    }

    public get isPost(): boolean {
        return this.prePostFlag?.toLowerCase() === 'post';
    }

    public get isPrePost(): boolean {
        return this.prePostFlag?.toLowerCase() === 'all';
    }

    public get availableForAllGuests(): boolean {
        return this.guestCod?.toLowerCase() === 'all';
    }

    public get availableGuestCods(): string[] {
        return this.guestCod?.split(',') || [];
    }

    public get availableDates(): DateTime[] {
        return this.allAvailableOptions.map((o) => o.date).filter(d => d?.isValid).sort((a, b) => +(a ?? 0) - +(b ?? 0)) as DateTime[];
    }
    public calculateDistinctInternalTransfer() {
        if (this.internalTransfer.length > 0) {
            const accomodations = this.amenityMatrix.filter(a => a.isSelected).flatMap(item => item.accomodations)
            const selectedGuestCodes = accomodations.flatMap(a => a.Guests).map(g => g.guestCod)
            const firstGestCod = this.internalTransfer[0].guestCod

            this.distinctInternalTransfer = this.internalTransfer
                .filter(item => item.guestCod == firstGestCod)
                .map(item => new ResSrvOptServiceDistinctInternalTransfer(item))

            this.distinctInternalTransfer
                .forEach(distinct => {
                    const allIT = this.internalTransfer
                        .filter(transfer =>
                            selectedGuestCodes.includes(transfer.guestCod)
                            && transfer.serviceGroupIdFrom === distinct.serviceGroupIdFrom
                            && transfer.serviceGroupIdTo === distinct.serviceGroupIdTo
                            && transfer.itineraryDate.equals(distinct.itineraryDate)
                            && transfer.serviceID === distinct.serviceID
                            && transfer.optionID === distinct.optionID
                        )
                    distinct.price = allIT.reduce((acc, t) => acc + t.price, 0)
                    distinct.cost = allIT.reduce((acc, t) => acc + t.cost, 0)
                    distinct.quantity = selectedGuestCodes.length
                    distinct.guestsInternalFligth = allIT
                })

        }
    }
    calculateUseGuidAccodation(booking:ResBooking, guestCods: string[]) {
      const bkgAcc = booking.getAccomodations(true)
      const bkgGuests = bkgAcc.flatMap(a => a.Guests)
      //                         .filter(g => guestCods.includes(g.guestCod))

      //resize rooms
      if(this.accomodations.length===0) {
        let idxRoom = 1
        let nr = ReservationAccomodation.newRoom(idxRoom)
        nr.RoomGUID = uuid()
        this.accomodations.push(nr)
        guestCods.forEach(gc=>{
          if(nr.Guests.length===(this.maxPax ?? 99)) {
            idxRoom++
            nr = ReservationAccomodation.newRoom(idxRoom)
            this.accomodations.push(nr)
          }
          const g = bkgGuests.find(g=>g.guestCod===gc)
          if(g) {
            nr.Guests.push(g)
          }
        })


        // if(this.priceSetupType === 'P') {
        //   guestCods.forEach((gc,idx)=>{
        //     const nr = ReservationAccomodation.newRoom(idx+1)
        //     const g = bkgGuests.find(g=>g.guestCod===gc)
        //     if(g) {
        //       nr.Guests.push(g)
        //     }
        //     this.accomodations.push(nr)
        //   })
        // } else {
        //   const nr = ReservationAccomodation.newRoom(1)
        //   guestCods.forEach(gc=>{
        //     const g = bkgGuests.find(g=>g.guestCod===gc)
        //     if(g) {
        //       nr.Guests.push(g)
        //     }
        //   })
        //   this.accomodations.push(nr)
        // }
      }

    }
    public formatOptionPrices(
        type: string,
        coreFormatService?: CoreFormatService
    ): string {
        if (!this[type] && this[type] !== 0) return '';

        if (this.isPercentage) return `${this[type]}%`;

        if (!coreFormatService) return typeof this[type] === 'number' ? this[type].toString() : this[type];

        const currency = type == 'cost' ? this.costCurrency : this.priceCurrency;

        return coreFormatService.CurrencyAmount(this[type], currency);
    }

    public formatOptionDate(coreFormatService?: CoreFormatService): string {
        if (!this.date || !coreFormatService) return '';
        return coreFormatService.DateToDefaultDateFormat(this.date);
    }

    public formatOptionAvailableDates() {
        return this.availableDates.map((d) => d.toJSDate());
    }

    public get hasOnlyOneDateAvailable(): boolean {
        return this.availableDates.length === 1;
    }

    public getPriceByDate(date: DateTime): number {
        const option = this.getAvailableOptionByDate(date);
        return option ? this.getFormattedPriceNumber(option) : 0;
    }

    public getAvailableOptionByDate(date: DateTime): ReservationServiceOption | undefined {
        if (!date?.isValid) return undefined;
        // const allOptions = this.allAvailableOptions.filter(o => !o.isExceptionFilterDateForGiftAndMerchandising)
        //                                             .concat(this.allAvailableOptionsGiftAndMerchandising.map(o => {
        //                                                 const newOption = Object.assign({}, o)
        //                                                 newOption.allAvailableOptions = o.allAvailableOptionsGiftAndMerchandising
        //                                                 return newOption
        //                                             }))
        return this.allAvailableOptions.find((o: ReservationServiceOption) => +(o.date ?? -1) === +date);
    }

    public getItineraryDateRange(): DateTime[] {
        if (!this.itineraryDateStart) return [];
        return RescomService.buildDateRange(this.itineraryDateStart, this.itineraryDateEnd);
    }

    public getAvailableSelectedOptions(): ReservationServiceOption[] {
        if (!this.allAvailableOptions?.length) return [];

        if (this.isExceptionFilterDateForGiftAndMerchandising && this.itineraryDateStart) {
            return [this.getAvailableOptionByDate(this.itineraryDateStart)].filter(o => !!o) as ReservationServiceOption[]
        }

        if (this.isIncluded && !this.onBoardUse) {
            if (!this.itineraryDateStart && !this.itineraryDateEnd) return [];
            if (this.onCheckIn && this.onCheckOut && this.itineraryDateStart && this.itineraryDateEnd) {
                return [this.getAvailableOptionByDate(this.itineraryDateStart), this.getAvailableOptionByDate(this.itineraryDateEnd)].filter((o) => !!o) as ReservationServiceOption[];
            }
            if (this.onCheckIn && this.itineraryDateStart) {
                return [this.getAvailableOptionByDate(this.itineraryDateStart)].filter((o) => !!o) as ReservationServiceOption[];
            }
            if (this.onCheckOut && this.itineraryDateEnd) {
                return [this.getAvailableOptionByDate(this.itineraryDateEnd)].filter((o) => !!o) as ReservationServiceOption[];
            }
            return [];
        }

        return this.getItineraryDateRange().map((d) => this.getAvailableOptionByDate(d)).filter((o) => !!o) as ReservationServiceOption[];
    }

    public getAvailableSelectedOptionsDetail(): IReservationOptionDetail[] {
        return this.getAvailableSelectedOptions().map(option => ({ sellingPrice: option.sellingPrice, formattedPrice: option.formattedPrice, formattedDate: option.formattedDate, formattedCost: option.formattedCost, formattedSellingTax: option.formattedSellingTax, serviceTypeID: this.serviceTypeID, serviceID: option.serviceID, optionID: option.optionID, priceCurrency: option.priceCurrency, date: option.date, isIncluded: this.isIncluded, valueType: option.valueType, onHoldQTY: option.onHoldQTY, isPercentage: this.isPercentage, onRequest: option.onRequest })).filter((detail, i, a) => a.findIndex(detail2 => +(detail.date ?? 0) === +(detail2.date ?? 0)) === i) as IReservationOptionDetail[];
    }

    public getTotalPrice(factor?: number): string {
        if (this.isPercentage) return this.sellingPrice + '%'

        //const currency = this.sellingPriceCurrency
        const currency = this.priceCurrency

        let priceNumber = this.availableSelectedOptionsDetail.reduce((acc, cur) => acc + (this.getFormattedPriceNumber(cur) ?? 0), 0)

        if (factor != undefined) priceNumber = priceNumber * factor

        return this.coreFormatService?.CurrencyAmount(priceNumber, currency) ?? ''
    }

    public getFormattedPriceNumber(option: ReservationServiceOption | IReservationOptionDetail): number {
        if (!option.formattedPrice) return 0;
        return RescomService.getNumberFromString(option.formattedPrice)
    }

    public recalculateSelectedOptionsDetail() {
        this.availableSelectedOptionsDetail = this.getAvailableSelectedOptionsDetail()
    }

    public get minOnHoldQTY(): number {
        const validQty = this.availableSelectedOptionsDetail.filter(o => o.onHoldQTY !== undefined)
        if (validQty.length === 0) return 0
        return Math.min(...validQty.map(o => o.onHoldQTY!))
    }

    public isDateAvailable(date: DateTime): boolean {
        if (!date?.isValid) return false
        return this.availableDates.some((d: DateTime) => +d === +date)
    }
}

export class ReservationServiceOptionGrouped extends ReservationServiceOption {
    dates: DateTime[] = []
}


export interface IReservationApiService {
    ServiceTypeID?: number;
    ServiceTypeName?: string;
    ServiceTypeDescription?: string;
    GuestConstraint?: string;
    ServiceID?: number;
    ServiceLongName?: string;
    ServiceShortName?: string;
    ServiceDescription?: string;
    InclusiveItems?: IReservationApiServiceOption[];
    SupplierID?: number;
    SupplierName?: string;
    OptionName?: string;
    ServiceDisplayNameUnique?: string;
    Country?: string;
    ServiceDisplayName?: string;
    StarCod?: string;
    StarDesc?: string;
    Amenities?: any[];
    Communications?: {Title: string, Notes: string}[];
    Offers?: {ServiceID?: number, Title: string, OfferCod: string, Night: number, Notes: string}[];
}

export interface IReservationOptionDetail {
    serviceTypeID?: number;
    serviceID?: number;
    optionID?: number;
    sellingPrice?: number,
    date?: DateTime,
    formattedPrice?: string,
    formattedDate?: string,
    formattedCost?: string,
    formattedSellingTax?: string,
    priceCurrency?: string,
    valueType?: string,
    isIncluded?: boolean,
    onHoldQTY?: number,
    isPercentage?: boolean,
    onRequest?: boolean
    quantityToAdd?: number
}

export interface IReservationApiGetServices {
    ServiceID?: number;
    RailStation?: string;
    ServiceLongName?: string;
    ServiceShortName?: string;
    ServiceDescription?: string;
    ServiceMaximumOccupancy?: number;
    ServiceTypeID?: number;
    SupplierID?: number;
    CompanyID?: number;
    SiteID?: number;
    SupplierName?: string;
    Country?: string;
    CityID?: number;
    IsVillaServiceSearch?: string;
    CompanyID_OVERWRITE?: number;
    BkgID?: number;
    DateFrom?: DateTime;
    DateTo?: DateTime;
}

export interface IReservationApiServiceOption {
    ServiceTypeID?: number;
    ServiceTypeName?: string;
    ServiceTypeDescription?: string;
    GuestConstraint?: boolean;
    ServiceID?: number;
    ServiceLongName?: string;
    ServiceShortName?: string;
    ServiceName?: string;
    ServiceDescription?: string;
    SupplierName?: string;
    OptionID?: number;
    OptionCod?: string;
    MinPax?: number;
    MaxPax?: number;
    NeedMessage?: string;
    CsFlag?: string;
    OptionName?: string;
    OptionShortName?: string;
    OptionDesc?: string;
    EstimatedCost?: number;
    Cost?: number;
    CostTypeID?: number;
    CostCurrency?: string;
    PriceSetUp?: string;
    SellingPrice?: number;
    SellingPriceCurrency?: string;
    SellingTax?: number;
    CostTax?: number;
    PriceCurrency?: string;
    Currency?: string;
    Margin?: number;
    Date?: string;
    ValueType?: 'Amount' | 'Percentage';
    StartDate?: string;
    EndDate?: string;
    Message?: string;
    PrePostFlag?: string;
    CommissionableSO?: string;
    OnHoldQTY?: number;
    GuestCod?: string;
    OnBoardUse?: boolean;
    IsIncluded?: string;
    SelfIncluded?: string;
    INCServiceTypeID?: number;
    OnRequest?: boolean;
    ERES?: boolean;
    Amenities: any[];
    Calendar: any[];
    CostGrid: any[];
    CityTaxGrid: any[];
    ServiceTaxGrid: any[];
    Occupancy: any[];
    UsedServiceType: any[];
    InternalFligth: any[];
}

export interface IResApiGetSetupServicesOptions {
    ServiceIDOption?: number
    ServiceID?: number
    OptionID?: number
    OptionName?: string
    IsIncluded?: 'Y' | 'N'
    IsActive?: 'Y' | 'N'
    PriceSetup?: string
    PageSize?: number
    IsServiceSetup?: 'Y' | 'N'
}
export class ReservationSetupServiceOption extends SafeBaseObject {
    brandID?: number
    commissionableSO: boolean | string = false
    commissionable: boolean | string = false
    cityID?: number
    city?: string
    isSBC = false
    maxPax: number
    minPax: number
    optionDesc: string
    optionID?: number
    optionName: string
    optionShortName: string
    refundable = false
    isIncluded: string
    status: string
    taxTypeID?: number
    taxValue?: number
    currency: string
    endDate?: DateTime
    message: string
    priceSetupID?: number
    priceSetup?: string
    serviceID?: number
    serviceName: string
    startDate?: DateTime
    discount?: number
    discountType?: string
    selfIncluded?: boolean
    usageTime?: string
    minAge?: number
    maxAge?: number
    duration?: number
    meal?: string
    startTime: DateTime | null = null
    serviceOptionID?: number
    serviceToServiceOptionID?: number
    serviceTypeIDSO?: number
    serviceTypeID?: number
    allServiceOptionsAdditional: ResServiceOptionAdditionalService[] = []
    bedType?: string | string[] = []
    srvOptAmenities?: string | string[] = []
    mealPlan?: string | string[] = []
    mealPlanLookups: { ServiceLookupCod: string; Desc: string }[] = []
    bedTypeLookups: { ServiceLookupCod: string; Desc: string }[] = []
    costSource?: string | string[] = []
    override: string | boolean = false
    serviceDescription?: string

    occupancyRuleID?: number
    occupancyMax?: number
    occupancyMinAdults?: number
    occupancyMaxAdults?: number
    occupancyMaxChild?: number
    occupancyRules: ResServiceOptionOccupancyRule[] = []
    packageOnly: string | boolean = false
    ChildRules?: IResApiManageOccupancyChildRules[]
    OccRule?: IResApiManageServiceOptionOccRules[]
    srvBkgID?: number

    get formattedStartDate(): string {
        if (DateTime.isDateTime(this.startDate) && this.startDate.isValid) {
            return this.startDate?.toFormat('dd MMM yyyy')
        }
        return ''
    }

    get formattedEndDate(): string {
        if (DateTime.isDateTime(this.endDate) && this.endDate.isValid) {
            return this.endDate.toFormat('dd MMM yyyy')
        }
        return ''
    }

    get formattedStatus(): string {
        switch (this.status) {
            case 'A':
                return 'Active'
            case 'D':
                return 'Deleted'
            case 'B':
                return 'Inactive'
            default:
                return ''
        }
    }

    get seats(): string {
        return (this.maxPax ?? 0) + ' seats'
    }

    constructor(data?: any) {
        super()
        this.isIncluded = 'N'
        this.maxPax = 0
        this.minPax = 0
        this.optionDesc = ''
        this.optionName = ''
        this.optionShortName = ''
        this.status = ''
        this.currency = ''
        this.message = ''
        this.serviceName = ''

        if (data) {
            this.updateData(data)
            if (Array.isArray(data?.MealPlan)) this.mealPlanLookups = data.MealPlan
            if (Array.isArray(data?.BedTypes)) this.bedTypeLookups = data.BedTypes
            else if (Array.isArray(data?.BedType)) this.bedTypeLookups = data.BedType
            if (data?.Amenities) {
                this.allServiceOptionsAdditional = data?.Amenities.map((amenity: any) => new ResServiceOptionAdditionalService(amenity)) ?? []
                this.bedType = this.allServiceOptionsAdditional.filter((amenity: ResServiceOptionAdditionalService) => amenity.scope === 'BedType')
                    .map((amenity: ResServiceOptionAdditionalService) => amenity.cod) ?? []
                this.mealPlan = this.allServiceOptionsAdditional.filter((amenity: ResServiceOptionAdditionalService) => amenity.scope === 'MealPlan')
                    .map((amenity: ResServiceOptionAdditionalService) => amenity.cod) ?? []
                this.costSource = this.allServiceOptionsAdditional.filter((amenity: ResServiceOptionAdditionalService) => amenity.scope === 'CostSource')
                    .map((amenity: ResServiceOptionAdditionalService) => amenity.cod) ?? []
                this.srvOptAmenities = this.allServiceOptionsAdditional.filter((amenity: ResServiceOptionAdditionalService) => amenity.scope === 'SrvOptAmenities')
                    .map((amenity: ResServiceOptionAdditionalService) => amenity.cod) ?? []
            }
            if (data?.Occupancy) {
                this.occupancyRules = data.Occupancy.map((item: any) => new ResServiceOptionOccupancyRule(item)) ?? []
            }
        }
    }

    override updateData(data: any): void {
        this.addMangledProperty(data)
        this.addBooleanProperty('isIncluded', data, 'IsIncluded')
        this.addBooleanProperty('selfIncluded', data, 'SelfIncluded')
        this.addDateTimeProperty('endDate', data, 'EndDate')
        this.addDateTimeProperty('startDate', data, 'StartDate')
    }

    get available(): boolean {
        return this.status?.toLowerCase() === 'a'
    }

    get deleted(): boolean {
        return this.status?.toLowerCase() === 'd'
    }
}

export class ResServiceOptionAdditionalService extends SafeBaseObject {
    serviceFeatureID = 0
    serviceID = 0
    optionID = 0
    serviceLookupCod = ''
    scope = ''
    position = 0
    cod = ''
    desc = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export interface IResComApiGetServicesSearch {
    ServiceID?: number
    ServiceLongName?: string
    ServiceShortName?: string
    ServiceTypeID?: number
    ServiceTypeName?: string
    SupplierID?: number
    SupplierName?: string
    CountryCod?: string
    City?: string
    Country?: string
    Currency?: string
    PriceSetupID?: number
    PriceSetup?: string
    CityID?: number
    HotelUniqueID?: number
    CompanyID_OVERWRITE?: number
    IsServiceSetup?: string
    IsVillaServiceSearch?: string
    FormattedStatus?: string
    GeoTreeID?: number
    IsFastBuild?: string
}

export interface IRescomApiItinerary {
    VoyageID?: number
    PackageID?: number
}

export class RescomItinerary extends SafeBaseObject {
    productCod = ''
    productID = 0
    itnID = 0
    pos = 0
    day = 0
    cityID = 0
    cityCod = ''
    portCod = ''
    cityName = ''
    latitude = 0
    longitude = 0
    countryCod = ''
    country = ''
    itineraryDayDesc = ''
    itineraryDayText = ''
    itineraryDate = DateTime.invalid('empty')
    arrivalTime = DateTime.invalid('empty')
    embarkFrom = DateTime.invalid('empty')
    embarkTo = DateTime.invalid('empty')
    debarkFrom = DateTime.invalid('empty')
    debarkTo = DateTime.invalid('empty')
    departTime = DateTime.invalid('empty')
    pierID = 0
    portAgent = ''
    portAgentPhone = ''
    shuttleInfo = ''
    staffInfo = ''
    hospitalityInfo = ''
    dockAnchor = false
    isOvernight = false

    details: RescomItineraryDetails[] = []

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
    override updateData(data?: any) {
        if (!data) return
        super.updateData(data)

        this.details = data.Details?.map((det: any) => new RescomItineraryDetails(det)) ?? []
    }
}

export class RescomItineraryDetails extends SafeBaseObject {
    productCod = ''
    productID = 0
    day = 0
    serviceID = 0
    name = ''
    description = ''
    longDescription = ''
    image1 = ''
    image2 = ''
    image3 = ''
    image4 = ''
    image5 = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
    override updateData(data?: any) {
        if (!data) return
        super.updateData(data)

    }
}

export class ResSupplierContactList extends SafeBaseObject {
    supplierID?: number
    supplierName?: string
    companyID?: number
    tradingCompany?: string
    mainContact?: string
    contactTypeCod?: string
    title?: string
    firstName?: string
    lastName?: string
    jobTitle?: string
    phone?: string
    email?: string
    addressTypeCod?: string
    address?: string
    cityID?: number
    city?: string
    countryCod?: string
    zip?: string
    note?: string

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export class ResSupplierUniqueContactList extends SafeBaseObject {
    supplierUniqueID?: number
    supplierUniqueName?: string
    rFC?: string
    address?: string
    zip?: string
    cityID?: number
    city?: string
    phone?: string
    email?: string
    countryCod?: string
    countyID?: number
    country?: string
    stateID?: number
    supplierAccountCod?: string
    buyer?: string
    currency?: string
    supplierID?: number
    supplierName?: string
    interCompanyID?: number
    tradingCompany?: string

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export interface IResApiGetServiceReport {
    ServiceID?: number
    CompanyID?: number
    ServiceShortName?: string
    ServiceLongName?: string
    ServiceTypeID?: number
    SupplierID?: number
    SupplierName?: string
    CityID?: number
    CountryCod?: string
    Currency?: string
    HotelUniqueID?: number
}

export class ResContractItem extends SafeBaseObject {
    itemContractID = 0
    serviceID = 0
    experienceID = 0
    packageID = 0
    year = 0
    fileName = ''
    fileID = 0
    fileGuid = ''
    notes = ''
    internalNotes = ''
    status = 'A'
    dateFrom = DateTime.invalid('empty')
    dateTo = DateTime.invalid('empty')
    name = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export interface IResApiGetContractItems {
    ServiceID?: number
    ExperienceID?: number
    PackageID?: number
    Year?: number
    FileName?: string
    FileID?: number
    FileGuid?: string
}

export interface IResApiManageContractItems {
    ItemContract: IResApiContractItemRow[]
}

export interface IResApiContractItemRow {
    ItemContractID?: number
    ServiceID?: number
    ExperienceID?: number
    PackageID?: number
    Year?: number
    FileName?: string
    FileID?: number
    FileGuid?: string
    Notes?: string
    InternalNotes?: string
    Name?: string
    DateFrom?: DateTime
    DateTo?: DateTime
    Status?: string
}

export interface IResApiGetCommunicationItems {
    ServiceID?: number
    ExperienceID?: number
    PackageID?: number
    ItemCommunicationTypeID?: number
}

export interface IResApiManageCommunicationItems {
    ItemCommunication: IResApiCommunicationItemRow[]
}

export interface IResApiCommunicationItemRow {
    ItemCommunicationID?: number
    ItemCommunicationTypeID?: number
    ServiceID?: number
    ExperienceID?: number
    PackageID?: number
    DateFrom?: DateTime
    DateTo?: DateTime
    Night?: number
    TitleCod?: string
    Notes?: string
    InternalNotes?: string
    Status?: string
    DisplayBkgFlow?: string
    OfferCod?: string
}

export class ResCommunicationItem extends SafeBaseObject {
    itemCommunicationID = 0
    itemCommunicationTypeID = 0
    serviceID = 0
    experienceID = 0
    packageID = 0
    dateFrom = DateTime.invalid('empty')
    dateTo = DateTime.invalid('empty')
    night = 0
    titleCod = ''
    titleDesc = ''
    offerCod = ''
    notes = ''
    internalNotes = ''
    status = 'A'
    displayBkgFlow = false

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export class ResCommunicationItemType extends SafeBaseObject {
    itemCommunicationTypeID = 0
    itemCommunicationType = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export class ReservationConsortium extends SafeBaseObject {
    agencyCode = ''
    agency = ''

    //not in api resp
    isSelected = false

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export class ReservationServiceConsortium extends SafeBaseObject {
    serviceConsortiumID = 0
    serviceID = 0
    agencyCode = ''
    agency = ''
    startDate = DateTime.invalid('empty')
    endDate = DateTime.invalid('empty')

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export class ResSrvAccAudit extends SafeBaseObject {
    serviceID = 0
    hotelUniqueID = 0
    auditID = 0
    auditType = ''
    latestDate = DateTime.invalid('empty')
    gradeDescription = ''
    currentGrade = ''
    previousGrade = ''

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiGetServiceAudit {
    CompanyIDs: string
    ServiceTypeIDs: string
}

export class ReservationServiceAuditListItem extends SafeBaseObject {
    company = ''
    serviceID = 0
    serviceLongName = ''
    serviceShortName = ''
    status = ''
    serviceTypeID = 0
    serviceTypeName = ''
    supplierID = 0
    supplierName = ''
    supplierUniqueID = 0
    supplierUniqueName = ''
    dmcSupplier = ''
    dmcSupplierUnique = ''
    country = ''
    countyCod = ''
    zip = ''
    address = ''
    cityID = 0
    city = ''
    geoTreeID = 0
    geoTreeName = ''
    mainCurrency = ''
    packageOnly = ''
    excludeAvailability = ''
    serviceTermsInclusions = ''
    serviceTermsExclusions = ''
    hotelName = ''
    latitude = 0
    longitude = 0
    salesDescription = ''
    salesDescriptionAI = ''
    operationalDescription = ''
    operationalDescriptionAI = ''
    bestSuitedFor = ''
    specialInterest = ''
    accommodationStyle = ''
    mobility = ''
    checkIN = ''
    checkOUT = ''
    fastBuild = false
    bkgID = 0

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export class ReservationServiceOptionAuditListItem extends SafeBaseObject {
    company = ''
    serviceID = 0
    serviceLongName = ''
    serviceTypeID = 0
    serviceTypeName = ''
    supplierName = ''
    serviceStatus = ''
    optionID = 0
    optionName = ''
    optionStatus = ''
    packageOnly = ''
    occupancyRule = ''
    costYear = 0
    costSource = ''
    costSourceDesc = ''
    isEstimated = ''
    currency = ''
    stoPerc = 0
    vat = 0
    vatIncluded = ''
    childCostPresent = ''
    paxBandPresent = ''
    bandDateFrom = ''
    bandDateTo = ''
    bandCost = 0
    bandCurrency = ''
    guestFrom = 0
    guestTo = 0
    dayFrom = 0
    dayTo = 0

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiGetOccupancyRules {
    OccupancyRuleID?: number
    OccupancyRule?: string
}

export class ResOccupancyRule extends SafeBaseObject {
    occupancyRuleID = 0
    occupancyRule = ''
    occupancyMessage = ''
    maxOccupancy = 0
    minAdults = 0
    maxAdults = 0
    maxChild = 0
    child1FromAge = 0
    child1ToAge = 0
    child2FromAge = 0
    child2ToAge = 0

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiGetOccupancyChildRules {
    OccupancyRuleChildID?: number
    ServiceID?: number
    OptionID?: number
}

export class ResOccupancyChildRule extends SafeBaseObject {
    occupancyRuleChildID = 0
    serviceID = 0
    optionID = 0
    fromAge = 0
    toAge = 0
    quantity = 0
    includeInMaxOccupancy = false
    note = ''
    status = 'A'

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiManageOccupancyChildRules {
    OccupancyRuleChildID?: number
    ServiceID?: number
    OptionID?: number
    FromAge?: number
    ToAge?: number
    Quantity?: number
    IncludeInMaxOccupancy?: string
    Note?: string
    Status?: string
}

export interface IResApiGetServiceOptionOccRules {
    ServiceID?: number
    OptionID?: number
}

export class ResServiceOptionOccupancyRule extends SafeBaseObject {
    serviceOptionToOccupancyRuleID = 0
    serviceID = 0
    optionID = 0
    occupancyRuleID = 0
    status = 'A'
    occupancyMax?: number
    occupancyMinAdults?: number
    occupancyMaxAdults?: number
    occupancyMaxChild?: number

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiManageServiceOptionOccRules {
    ServiceOptionToOccupancyRuleID?: number
    ServiceID?: number
    OptionID?: number
    OccupancyRuleID?: number
    Status?: string
}

export interface IResApiGetServiceSetupFlightDetail {
    ServiceID: number
    OptionID?: number
}

export class ResServiceSetupFlightDetail extends SafeBaseObject {
    flightDetailID = 0
    flightNo = ''
    airlineID?: number
    order = 0
    airportFromID?: number
    timeFrom?: DateTime
    airportToID?: number
    timeTo?: DateTime
    status = 'A'

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiManageServiceSetupFlightDetail {
    FlightRoute: IResApiManageServiceSetupFlightDetailRow[]
}
export interface IResApiManageServiceSetupFlightDetailRow {
    FlightDetailID?: number
    ServiceID?: number
    FlightNo?: string
    Order?: number
    AirportFromID?: number
    TimeFrom?: DateTime
    AirportToID?: number
    TimeTo?: DateTime
    Status?: string
    AirlineID?: number
}

export class ResServiceDataAirports extends SafeBaseObject {
    airportID = 0
    iataCod = ''
    airport = ''

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export class ResServiceSetupServiceGroup extends SafeBaseObject {
    serviceGroupID = 0
    serviceGroup = ''

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export class ResSupplierServiceCost extends SafeBaseObject {
    serviceID = 0
    serviceName = ''
    optionName = ''
    optionID = 0
    serviceTypeID = 0
    serviceType = ''
    lastPeriodFrom = DateTime.invalid('empty')
    lastPeriodTo = DateTime.invalid('empty')
    isEstimated = false
    serviceGroup = ''
    serviceGroupID = 0

    isSelected = false

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export class ResSupplierServicesInsertedData extends SafeBaseObject {
    serviceID = 0
    optionID = 0
    dateFrom = DateTime.invalid('empty')
    dateTo = DateTime.invalid('empty')
    isEstimated = false

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export class ResSupplierServiceCostData extends SafeBaseObject {
    dateTo?: DateTime
    dateFrom?: DateTime
    year?: number
    marginCost?: number
    marginCityTax?: number
    marginVAT?: number
    marginServiceTax?: number
    isBandCost = false
    isSgjCost = false
    isCostChild = false
    isNormalCost = false
    isHolidayMarkup = false

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}

export interface IResApiManageSupplierServiceCost {
    Cost: IResApiSupplierServiceCostRow[]
}
export interface IResApiSupplierServiceCostRow {
    DateFrom?: DateTime
    DateTo?: DateTime
    LastPeriodFrom?: DateTime
    LastPeriodTo?: DateTime
    ServiceID?: number
    OptionID?: number
    MarginCost?: number
    MarginCityTax?: number
    MarginVAT?: number
    MarginServiceTax?: number
    IsNormalCost?: string
    IsBandCost?: string
    IsSGJCost?: string
    IsCostChild?: string
    Year?: number
}

export class ResServiceSetupOverrideDescription extends SafeBaseObject {
    serviceDescriptionByDateID = 0;
    serviceID = 0;
    startDate = DateTime.invalid('empty');
    endDate = DateTime.invalid('empty');
    serviceDesc = '';
    serviceDescAI = '';
    status = 'A';

    constructor(data?: any) {
        super();
        if (data) {
            this.updateData(data);
        }
    }
}

export interface IResApiManageServiceOverrideDescription {
    ServiceID: number
    SrvDesc: IResApiManageServiceOverrideDescriptionRow[]
}
export interface IResApiManageServiceOverrideDescriptionRow {
    ServiceDescriptionByDateID?: number
    ServiceID: number
    StartDate: DateTime
    EndDate: DateTime
    ServiceDesc?: string
    ServiceDescAI?: string
    Status: string
}

export type ResServiceNoteType = 'Setup' | 'Package' | 'Cost'

export interface IResApiGetServiceNotes {
    ServiceID: number
    NoteType: ResServiceNoteType
}

export class ResServiceNote extends SafeBaseObject {
    serviceID = 0;
    noteType = '';
    section = '';
    action = '';
    changeDate = DateTime.invalid('empty');
    changeUser = '';

    constructor(data?: any) {
        super();
        if (data) this.updateData(data);
    }
}
